import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, DateAdapter, MAT_DATE_FORMATS } from '@angular/material';
import { Data } from '@angular/router';
import { FormControl, Validators } from '@angular/forms';
//import moment = require('moment');
import * as moment from "moment";
import { DateAdapterService, APP_DATE_FORMATS } from '../../../services/date-adapter.service';
import { CampaignService } from 'src/app/services/campaign/campaign.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-downloaddatedialog',
  templateUrl: './downloaddatedialog.component.html',
  styleUrls: ['./downloaddatedialog.component.scss'],
  providers: [
    {
      provide: DateAdapter, useClass: DateAdapterService
    },
    {
      provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS
    }
  ]
})
export class DownloaddatedialogComponent implements OnInit {

  startDate = new FormControl('', [Validators.required]);
  endDate = new FormControl('', [Validators.required]);
  minDate: Date = new Date();
  startTime=1;
  endTime=1;
 // maxDate: Date = new Date();
  endMinDate = moment(this.minDate).add('d', 1).toDate();
  dateVisible = true;
  todayDate: Date = new Date();
  todayDateYear: number ;
  todayDateMonth: number;
  todayDateDay: number ;
  startDateDay : any ;
  startDateMonth : any;
  startDateYear : any;
  body: any;

  constructor(
    public dialogRef: MatDialogRef<DownloaddatedialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Data,
    private campaignService:CampaignService,
    private spinnerService: Ng4LoadingSpinnerService) {
      this.minDate=this.data.createdDate;
      this.startDate.setValue(this.data.createdDate);
       this.endDate.setValue(this.data.endDate);
       this.endMinDate= moment(this.startDate.value).add('d', 1).toDate();
     }

  ngOnInit() {
  }

  onNoClick() {
    this.dialogRef.close();
  }

  getStartDate(): any {  
    console.log("ABCDE", this.dateVisible);
    if (this.startDate.value !== '' && this.startDate.value != null) {
      console.log("ABCDE", this.dateVisible);
      this.dateVisible = false;
      console.log("ABCDE1", this.dateVisible);
      this.todayDateYear = this.todayDate.getFullYear();
      this.todayDateMonth = this.todayDate.getMonth() + 1;
      this.todayDateDay = this.todayDate.getDate();
      this.startDateDay = this.startDate.value.getDate();
      this.startDateMonth = this.startDate.value.getMonth() ;
      this.startDateYear = this.startDate.value.getFullYear();
      this.endMinDate = new Date(  this.startDateYear , this.startDateMonth , this.startDateDay );
      return true;
    }
  }

  submit() {
    this.spinnerService.show();
    console.log("Start date:",this.startDate.value);
    console.log("End date:",this.endDate.value);
    let body = {
      campaignStartDate: moment(this.startDate.value).format('YYYY-MM-DDTHH:mm:ss'),
      campaignShortName:this.data.campaignShortName,
      campaignEndDate: moment(this.endDate.value).format('YYYY-MM-DDTHH:mm:ss'),
      campaignStartDayTime: this.startTime,
      campaignEndDayTime: this.endTime
    };
    console.log('body:', this.body);
    this.dialogRef.close({
      body
    });
    
  }
}

